import React, { memo } from 'react';
import { VictoryLabel, VictoryLabelProps } from 'victory';

export const DataLabel = (props: VictoryLabelProps) => {
    const { x } = props;
    return <VictoryLabel {...props} textAnchor='middle' x={x + 18} />;
};